import { actions as formActions } from 'react-redux-form'
import { t } from 'ttag'



import * as h2Api from '../../h2Api'
import { browserHistory } from '../../Routes'




export const initialLessonModel = {
  name: '',
  description: '',
  educatorDescription: '',
  gradeLevelMin: '',
  gradeLevelMax: '',
  shared: false,
  tasks: []
}

export const initialLessonSequenceModel = {
  name: '',
  description: '',
  lessonIds: [],
  shared: false
}

export const initialPrivilegedModel = {
  segment: dynamicValues && dynamicValues.tenantId,
  subSegment: dynamicValues && dynamicValues.subTenantId,
  system: false,
  group: '',
  subscriptionOnly: false,
  weight: ''
}

export const initialTaskModel = {
  type: 0,
  title: '',
  description: '',
  notesRequired: false,
  due: ''
}

export const grades = [
  { name: t`Professional Development`, value: 14 },
  { name: t`Higher Ed`, value: 13 },
  { name: t`12th Grade`, ordinalName: '12th', value: 12 },
  { name: t`11th Grade`, ordinalName: '11th', value: 11 },
  { name: t`10th Grade`, ordinalName: '10th', value: 10 },
  { name: t`9th Grade`, ordinalName: '9th', value: 9 },
  { name: t`8th Grade`, ordinalName: '8th', value: 8 },
  { name: t`7th Grade`, ordinalName: '7th', value: 7 },
  { name: t`6th Grade`, ordinalName: '6th', value: 6 },
  { name: t`5th Grade`, ordinalName: '5th', value: 5, isNavianceElementary: true },
  { name: t`4th Grade`, ordinalName: '4th', value: 4, isNavianceElementary: true },
  { name: t`3rd Grade`, ordinalName: '3rd', value: 3, isNavianceElementary: true },
  { name: t`2nd Grade`, ordinalName: '2nd', value: 2, isNavianceElementary: true },
  { name: t`1st Grade`, ordinalName: '1st', value: 1, isNavianceElementary: true },
  {
    name: t`Kindergarten`,
    ordinalName: 'Kindergarten',
    value: 0,
    isNavianceElementary: true
  }
]

export const gradeName = (gradeValue, shortName = false) => {
  const { name, ordinalName } = grades.find(grade => grade.value === gradeValue) || {
    name: 'Unknown'
  }

  return shortName ? ordinalName : name
}

export const APPROVE_REJECT = 'APPROVE_REJECT_LESSON'

export const LOAD_QUEUE_LIST = 'LOAD_QUEUE_LIST'

export const LOAD_QUEUE = 'ADMIN_LOAD_QUEUE'

export const LOAD_LESSONS = 'ADMIN_LESSONS_LOAD'

export const LOAD_TASK_TYPES = 'ADMIN_LESSONS_LOAD_TASK_TYPES'

export const SAVE_LESSON = 'ADMIN_LESSONS_SAVE'

export const SELECT_LESSON = 'ADMIN_LESSONS_SELECT'

export const UPDATE_LESSON = 'ADMIN_LESSONS_UPDATE'

export const UPDATE_PRIVILEGED = 'ADMIN_LESSONS_PRIVILEGED_UPDATE'

export const ASSIGN_LESSON = 'ADMIN_LESSONS_ASSIGN'

export const UNASSIGN_LESSON = 'ADMIN_LESSONS_UNASSIGN'

export const UNASSIGN_LESSON_FROM = 'ADMIN_UNASSIGN_LESSON_FROM'

export const COPY_LESSON = 'ADMIN_LESSONS_COPY'

export const DELETE_LESSON = 'ADMIN_LESSONS_DELETE'

export const SAVE_TASK = 'ADMIN_LESSONS_SAVE_TASK'

export const UPDATE_TASK = 'ADMIN_LESSONS_UPDATE_TASK'

export const DELETE_TASK = 'ADMIN_LESSONS_DELETE_TASK'

export const MOVE_TASK = 'ADMIN_LESSONS_MOVE_TASK'

export const MERGE_STATE = 'ADMIN_LESSONS_MERGE_STATE'

export const ACKNOWLEDGE_TUTORIAL = 'ADMIN_ACKNOWLEDGE_ASSIGNMENT_TUTORIAL'

export const PLAN_USER_ASSIGNMENT_LIST = 'ADMIN_PLAN_USER_ASSIGNMENT_LIST'

export const SELECT_LESSON_FOR_ASSIGN = 'ADMIN_USER_SELECT_LESSON_FOR_ASSIGN'

export const SELECT_LESSON_FOR_EDIT = 'ADMIN_SELECT_LESSON_FOR_EDIT'

export const UPDATE_LESSON_SEARCH_FILTER = 'ADMIN_UPDATE_LESSON_SEARCH_FILTER'

export const ROOT_MARK_COMPLETE = 'ROOT_MARK_COMPLETE'

export const LIST_LEARNING_STANDARDS = 'LIST_LEARNING_STANDARDS'

export const SAVE_LESSON_SEQUENCE = 'SAVE_LESSON_SEQUENCE'

export const UPDATE_LESSON_SEQUENCE = 'UPDATE_LESSON_SEQUENCE'

export const SELECT_LESSON_SEQUENCE = 'SELECT_LESSON_SEQUENCE'

export const ADD_LESSON_TO_SEQUENCE = 'ADD_LESSON_TO_SEQUENCE'

export const DELETE_LESSON_FROM_SEQUENCE = 'DELETE_LESSON_FROM_SEQUENCE'

export const usersPlanAssignedTo = planId => dispatch => {
  return dispatch(
    h2Api.get(`/admin/lessons/assignments/${planId}`)({ type: PLAN_USER_ASSIGNMENT_LIST })
  )
}

export const loadLessons = params => {
  return h2Api.post('/admin/lessons/list', params)({ type: LOAD_LESSONS })
}

export const clearLesson = () => {
  return formActions.reset('admin.lessons.lessonForm')
}

export const newLesson = () => dispatch => {
  dispatch(clearLesson())
  browserHistory.push('/admin/assignments/wizard')
}

export const updateLessonSequence = sequence => dispatch => {
  return dispatch(
    h2Api.put(
      `/admin/lessons/sequence/${sequence.id}`,
      sequence
    )({ type: UPDATE_LESSON_SEQUENCE })
  ).then(lesson => {
    const { tenant: { tenantId = '', subTenantId = '' } = {} } = lesson
    const flattenedLesson = { ...lesson, segment: tenantId, subSegment: subTenantId }

    dispatch(
      formActions.change('admin.lessons.lessonSequenceForm', {
        ...initialLessonSequenceModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.lessonSequenceForm'))
    dispatch(
      formActions.change('admin.lessons.privilegedForm', {
        ...initialPrivilegedModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.privilegedForm'))

    return lesson
  })
}

export const saveLessonSequenceOnly = sequence => dispatch => {
  const { lessons: lessonObjects, ...toSubmit } = sequence
  const lessons = lessonObjects?.map(l => l.id)

  return dispatch(
    h2Api.post('/admin/lessons/sequence', { lessons, ...toSubmit })({
      type: SAVE_LESSON_SEQUENCE
    })
  )
}

export const saveLessonOnly = lesson => dispatch => {
  const { standards, ...restOfForm } = lesson
  const learningStandards = standards?.map(s => s.id)
  const toSubmit = {
    ...restOfForm,
    learningStandards
  }

  return dispatch(
    h2Api.post('/admin/lessons/saveLesson', toSubmit)({ type: SAVE_LESSON })
  ).then(lesson => {
    const { tenant: { tenantId = '', subTenantId = '' } = {} } = lesson
    const flattenedLesson = { ...lesson, segment: tenantId, subSegment: subTenantId }

    dispatch(
      formActions.change('admin.lessons.lessonForm', {
        ...initialLessonModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.lessonForm'))
    dispatch(
      formActions.change('admin.lessons.privilegedForm', {
        ...initialPrivilegedModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.privilegedForm'))

    return lesson
  })
}

export const getNextAssignmentInQueue = offset => (dispatch, getState) => {
  const filter = getState().admin.lessonSearch
  let queryStr = ''

  if (offset > 0) {
    queryStr = `?offset=${offset}`
  }


  return dispatch(
    h2Api.post(`/admin/lessons/queue${queryStr}`, filter)({ type: LOAD_QUEUE })
  )
}

export const getAssignmentInQueueById = id => dispatch => {
  return dispatch(h2Api.get(`/admin/lessons/queue/${id}`)({ type: LOAD_QUEUE }))
}

export const getAllAssignmentsInQueue = () => (dispatch, getState) => {
  const filter = getState().admin.lessonSearch

  return dispatch(
    h2Api.post(`/admin/lessons/queue/entries`, filter)({ type: LOAD_QUEUE_LIST })
  )
}

export const approveLesson = (lessonId, form) => dispatch => {
  const { tagId, ...newForm } = form

  return dispatch(
    h2Api.put(`/api/v2/management/assignments/approve/${lessonId}`, {
      ...newForm,
      tagId: tagId ? tagId.id : null
    })({ type: APPROVE_REJECT })
  )
}

export const approveLessons =
  (lessonIds, form = {}) =>
  dispatch => {
    const { tagId, ...newForm } = form

    return dispatch(
      h2Api.post(`/admin/lessons/queue/approve`, {
        ...newForm,
        lessonIds,
        tagId: tagId ? tagId.id : null
      })({ type: LOAD_QUEUE })
    )
  }

export const rejectLessonWithReason = (lessonId, comment) => dispatch => {
  return dispatch(
    h2Api.put(`/api/v2/management/assignments/reject/${lessonId}`, { reason: comment })({
      type: APPROVE_REJECT
    })
  )
}

export const saveLesson = lesson => dispatch => {
  return dispatch(saveLessonOnly(lesson)).then(lesson => {
    browserHistory.push(`/management/lessons/${lesson.id}/tasks/1`)
  })
}

export const lookupLesson = lessonId =>
  h2Api.post(`/admin/lessons/select/${lessonId}`)({ type: 'IGNORE' })

export const lookupSequence = sequenceId =>
  h2Api.get(`/admin/lessons/sequence/${sequenceId}`)({ type: 'IGNORE' })

export const selectSequence = sequenceId => dispatch => {
  return dispatch(
    h2Api.get(`/admin/lessons/sequence/${sequenceId}`)({ type: SELECT_LESSON_SEQUENCE })
  ).then(lesson => {
    const { tenant: { tenantId = '', subTenantId = '' } = {} } = lesson
    const flattenedLesson = { ...lesson, segment: tenantId, subSegment: subTenantId }

    dispatch(
      formActions.change('admin.lessons.lessonSequenceForm', {
        ...initialLessonSequenceModel,
        ...flattenedLesson
      })
    )
    dispatch(
      formActions.change('admin.lessons.privilegedForm', {
        ...initialPrivilegedModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.privilegedForm'))

    return lesson
  })
}

export const deleteLessonFromSequenceById = (sequenceId, lessonId) => {
  return h2Api.doDelete(`/admin/lessons/sequence/${sequenceId}/lesson/${lessonId}`)({
    type: DELETE_LESSON_FROM_SEQUENCE
  })
}

export const addLessonToSequenceById = (sequenceId, lessonId) => {
  return h2Api.put(
    `/admin/lessons/sequence/${sequenceId}/lesson/${lessonId}`,
    {}
  )({
    type: ADD_LESSON_TO_SEQUENCE
  })
}

export const selectLesson = lessonId => dispatch => {
  return dispatch(
    h2Api.post(`/admin/lessons/select/${lessonId}`)({ type: SELECT_LESSON, lessonId })
  ).then(lesson => {
    const { tenant: { tenantId = '', subTenantId = '' } = {} } = lesson
    const flattenedLesson = { ...lesson, segment: tenantId, subSegment: subTenantId }

    dispatch({ type: SELECT_LESSON_FOR_EDIT, selected: lesson })
    dispatch(
      formActions.change('admin.lessons.lessonForm', {
        ...initialLessonModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.lessonForm'))
    dispatch(
      formActions.change('admin.lessons.privilegedForm', {
        ...initialPrivilegedModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.privilegedForm'))

    return lesson
  })
}

export const updateLesson = lesson => dispatch => {
  return dispatch(
    h2Api.post(
      `/admin/lessons/updateLesson/${lesson.id}`,
      lesson
    )({ type: UPDATE_LESSON })
  ).then(lesson => {
    const { tenant: { tenantId = '', subTenantId = '' } = {} } = lesson

    dispatch({ type: SELECT_LESSON_FOR_EDIT, selected: lesson })
    const flattenedLesson = { ...lesson, segment: tenantId, subSegment: subTenantId }

    dispatch(
      formActions.change('admin.lessons.lessonForm', {
        ...initialLessonModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.lessonForm'))
    dispatch(
      formActions.change('admin.lessons.privilegedForm', {
        ...initialPrivilegedModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.privilegedForm'))

    return lesson
  })
}

export const updatePrivileged = lesson => dispatch => {
  return dispatch(
    h2Api.post(
      `/admin/lessons/updatePrivileged/${lesson.id}`,
      lesson
    )({ type: UPDATE_PRIVILEGED })
  ).then(lesson => {
    const { tenant: { tenantId = '', subTenantId = '' } = {} } = lesson

    dispatch({ type: SELECT_LESSON_FOR_EDIT, selected: lesson })
    const flattenedLesson = { ...lesson, segment: tenantId, subSegment: subTenantId }

    dispatch(
      formActions.change('admin.lessons.lessonForm', {
        ...initialLessonModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.lessonForm'))
    dispatch(
      formActions.change('admin.lessons.privilegedForm', {
        ...initialPrivilegedModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.privilegedForm'))

    return lesson
  })
}

export const updateSequencePrivileged = sequence => dispatch => {
  return dispatch(
    h2Api.put(
      `/admin/lessons/sequence/${sequence.id}/privileged`,
      sequence
    )({ type: UPDATE_PRIVILEGED })
  ).then(sequence => {
    const { tenant: { tenantId = '', subTenantId = '' } = {} } = sequence

    dispatch({ type: SELECT_LESSON_FOR_EDIT, selected: sequence })
    const flattenedLesson = { ...sequence, segment: tenantId, subSegment: subTenantId }

    dispatch(
      formActions.change('admin.lessons.privilegedForm', {
        ...initialPrivilegedModel,
        ...flattenedLesson
      })
    )
    dispatch(formActions.resetValidity('admin.lessons.privilegedForm'))

    return sequence
  })
}

export const deleteLesson = (page, lessonId) => dispatch => {
  return dispatch(
    h2Api.post(`/admin/lessons/deleteLesson/${lessonId}`)({
      type: DELETE_LESSON,
      lessonId
    })
  ).then(() => {
    dispatch(loadLessons({ numPerPage: 1000, page: 0 })).then(() =>
      dispatch(h2Api.resetRequest({ type: DELETE_LESSON, lessonId }))
    )
  })
}

export const copyLesson = (lessonId, copyForm) => dispatch => {
  //
;
  return dispatch(
    h2Api.post(
      `/admin/lessons/copyLesson/${lessonId}`,
      copyForm
    )({ type: COPY_LESSON, lessonId })
  ).then(lesson => {
    dispatch(h2Api.resetRequest({ type: COPY_LESSON }))
    browserHistory.push(`/management/lessons/${lesson.id}`)
  })
}

export const selectLessonToAssign = selectedLesson => dispatch => {
  return dispatch({ type: SELECT_LESSON_FOR_ASSIGN, selectedLesson })
}

export const assignLesson = (lessonId, criteria) => dispatch => {
  return dispatch(
    h2Api.post(`/admin/lessons/assignLesson/${lessonId}`, { criteria })({
      type: ASSIGN_LESSON,
      lessonId
    })
  )
}

export const rootMarkComplete = (lessonId, criteria) => dispatch => {
  //


  return dispatch(
    h2Api.post(
      `/admin/lessons/root/markComplete/${lessonId}`,
      criteria
    )({ type: ROOT_MARK_COMPLETE })
  )
}

export const unassignLesson = (lessonId, criteria) => dispatch => {
  return dispatch(
    h2Api.post(`/admin/lessons/unassignLesson/${lessonId}`, { criteria })({
      type: UNASSIGN_LESSON,
      lessonId
    })
  )
}

export const unassignLessonFrom = (lessonId, userId) => dispatch => {
  return dispatch(
    h2Api.post(
      `/admin/lessons/unassignLesson/${lessonId}/user/${userId}`,
      {}
    )({ type: UNASSIGN_LESSON, lessonId })
  )
}

export const loadTaskTypes = () => {
  return h2Api.post('/admin/lessons/taskTypes')({ type: LOAD_TASK_TYPES })
}

export const selectTaskById = id => (dispatch, getState) => {
  const {
    admin: {
      lessons: { lessonForm: selectedLesson }
    }
  } = getState()
  const isNew = id == -1
  let task = isNew ? initialTaskModel : selectedLesson.tasks.find(t => t.id == id)

  if (task && task.type === 13) {
    task = {
      ...task,
      link: task.referencedObjectId
    }
    //

  }

  //

  dispatch(formActions.change('admin.lessons.taskForm', { ...initialTaskModel, ...task }))
  dispatch(formActions.resetValidity('admin.lessons.taskForm'))
  dispatch(h2Api.resetRequest({ type: UPDATE_TASK }))
  dispatch(h2Api.resetRequest({ type: SAVE_TASK }))
}

export const changeTaskIndex = index => (dispatch, getState) => {
  const {
    admin: {
      lessons: { lessonForm: selectedLesson }
    }
  } = getState()
  const arrayIndex = index - 1
  const isNew = arrayIndex >= selectedLesson.tasks.length
  const task = isNew ? initialTaskModel : selectedLesson.tasks[arrayIndex]

  dispatch(formActions.change('admin.lessons.taskForm', { ...initialTaskModel, ...task }))
  dispatch(formActions.resetValidity('admin.lessons.taskForm'))
  dispatch(h2Api.resetRequest({ type: UPDATE_TASK }))
  dispatch(h2Api.resetRequest({ type: SAVE_TASK }))
}

export const saveTask = (lessonId, body) => dispatch => {
  const formData = new FormData()
  const { file, submittedFileAutoTagId, ...task } = body

  if (file) {
    Array.from(file).forEach(f => formData.append('file', f))
  }

  const tWith =
    submittedFileAutoTagId && submittedFileAutoTagId.hasOwnProperty('id')
      ? { ...task, submittedFileAutoTagId: submittedFileAutoTagId.id }
      : task

  formData.append('json', JSON.stringify(tWith))

  return dispatch(
    h2Api.postFile(`/admin/lessons/${lessonId}/saveTask`, formData)({ type: SAVE_TASK })
  ).then(task => {
    dispatch(formActions.push('admin.lessons.lessonForm.tasks', task))
    dispatch(
      formActions.change('admin.lessons.taskForm', { ...initialTaskModel, ...task })
    )

    return task
  })
}

export const updateTask = (lessonId, body) => dispatch => {
  const formData = new FormData()
  const { file, submittedFileAutoTagId, ...task } = body

  if (file) {
    Array.from(file).forEach(f => formData.append('file', f))
  }

  const tWith =
    submittedFileAutoTagId && submittedFileAutoTagId.hasOwnProperty('id')
      ? { ...task, submittedFileAutoTagId: submittedFileAutoTagId.id }
      : task

  formData.append('json', JSON.stringify(tWith))

  return dispatch(
    h2Api.postFile(
      `/admin/lessons/${lessonId}/updateTask/${task.id}`,
      formData
    )({ type: UPDATE_TASK })
  ).then(task => {
    dispatch(
      formActions.map('admin.lessons.lessonForm.tasks', t => {
        if (t.id === task.id) {
          return task
        }

        return t
      })
    )

    return task
  })
}

export const deleteTaskById = (lessonId, taskIndex) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/admin/lessons/${lessonId}/deleteTask/${taskIndex}`)({
      type: DELETE_TASK
    })
  ).then(lesson => {
    dispatch(formActions.change('admin.lessons.lessonForm.tasks', lesson.tasks))

    return lesson
  })
}

export const deleteTask = (lessonId, taskIndex) => (dispatch, getState) => {
  const {
    admin: {
      lessons: { lessonForm: selectedLesson }
    }
  } = getState()
  /*
   *
;
   *  const task = selectedLesson.tasks[taskIndex - 1]
   */

  //const index = selectedLesson.tasks.findIndex(t => t.id === task.id);
  return dispatch(deleteTaskById(lessonId, taskIndex)).then(lesson => {
    /*
     * const indexToUse = taskIndex
     * const tasks = lesson.tasks
     */

    browserHistory.push(`/management/lessons/${lessonId}`)

    return lesson
  })
}

export const moveTask = (lessonId, taskIndex, newIndex) => (dispatch, getState) => {
  const {
    admin: {
      lessons: { lessonForm: selectedLesson }
    }
  } = getState()
  //
;
  const task = selectedLesson.tasks[taskIndex - 1]

  return dispatch(
    h2Api.post(
      `/admin/lessons/${lessonId}/moveTask/${task.id}`,
      newIndex
    )({ type: MOVE_TASK })
  ).then(lesson => {
    dispatch(formActions.change('admin.lessons.lessonForm.tasks', lesson.tasks))

    return lesson
  })
}

export const moveTaskById = (lessonId, taskId, newIndex) => (dispatch, getState) => {
  return dispatch(
    h2Api.post(
      `/admin/lessons/${lessonId}/moveTask/${taskId}`,
      newIndex
    )({ type: MOVE_TASK })
  ).then(lesson => {
    dispatch(formActions.change('admin.lessons.lessonForm.tasks', lesson.tasks))

    return lesson
  })
}

export const populateTask = taskTypeId => (dispatch, getState) => {
  const {
    admin: {
      lessons: {
        taskTypesRequest: { result: taskTypes }
      }
    }
  } = getState()

  if (taskTypeId !== '') {
    const taskType = taskTypes.find(tt => tt.id.toString() === taskTypeId)

    if (taskType) {
      const toMerge = { title: taskType.title, description: taskType.description }

      dispatch(formActions.merge('admin.lessons.taskForm', toMerge))
    }
  }
}

export const loadLearningStandards = t => {
  const data = t?.trim().length >= 0 ? { term: t.trim() } : {}

  return h2Api.post(
    `/admin/lessons/learningStandards`,
    data
  )({ type: LIST_LEARNING_STANDARDS })
}

export const updateSearchFilter = (key, value) => dispatch => {
  return Promise.resolve(dispatch({ type: UPDATE_LESSON_SEARCH_FILTER, key, value }))
}

export const generatePropsForSearch = data => {
  const params = {
    numPerPage: 100,
    page: 1,
    grades: data.grades !== '' ? [parseInt(data.grades)] : []
  }

  if (data.term && data.term.length > 0) {
    params.term = data.term
  }

  if (data.owned) {
    params.owned = data.owned
  }

  if (data.shared) {
    params.shared = data.shared
  }

  if (data.unitsOnly) {
    params.unitsOnly = data.unitsOnly
  }


  return params
}
